<template>
	<div>
		<el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
					<el-button type="primary" size="mini" @click.native.prevent="selectRouting">
						{{$t('getapi[878]')}}
					</el-button>
					<el-button type="primary" size="mini" @click="deleteAll">{{$t('getapi[686]')}}</el-button>
					<el-upload
							class="upload-demo"
							ref="upload"
							:action="uploadurl"
							:on-preview="handlePreview"
							:on-remove="handleRemove"
							:on-change="handleChange"
							:on-success="handleSuccess"
							:on-error="handleError"
							:file-list="fileList"
							:limit="1"
							accept=".xlsx"
							style="margin-left: 8px"
					>
						<el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
					</el-upload>
					<el-button type="primary" size="mini" @click="setEnableFalse(0)" :disabled="!btn.enablefalse" v-if="iscontinue == 0" style="margin-left: 8px">{{ $t('getapi[215]') }}</el-button>
					<el-button type="primary" size="mini" @click="setEnableTrue(0)" :disabled="!btn.enabletrue" v-if="iscontinue == 0">{{ $t('getapi[147]') }}</el-button>
					<el-button type="primary" size="mini" @click="setEnableFalse(2)" :disabled="!btn.enablefalse" v-if="iscontinue == 2" style="margin-left: 8px">{{ $t('getapi[7210]')+$t('getapi[215]') }}</el-button>
					<el-button type="primary" size="mini" @click="setEnableTrue(2)" :disabled="!btn.enabletrue" v-if="iscontinue == 2">{{ $t('getapi[7210]')+$t('getapi[147]') }}</el-button>
				</div>
			</div>
		</el-card>
		<div id="xpane-0">
			<vxe-table
					:data="datajson"
					show-overflow
					ref='CloseSoTable'
					size="mini"
					:loading="loading"
					:height="tableHeight"
					stripe
					border
					resizable
					@checkbox-change="handleSelectionChange"
					@checkbox-all="handleSelectionChangeAll"
					@checkbox-range-end="handleSelectionChange">
				<vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="errmsg" :title="$t('getapi[715]')" width="350px" ></vxe-table-column>
                <vxe-table-column show-footer-overflow field="status" :title="$t('getapi[552]')" width="150" ></vxe-table-column>
				<vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')" width="150" ></vxe-table-column>
				<vxe-table-column show-footer-overflow field="part_name" :title="$t('getapi[116]')" width="150" ></vxe-table-column>
				<vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" width="100" ></vxe-table-column>
                <vxe-table-column show-footer-overflow field="part_status" :title="$t('getapi[114]')" width="100" ></vxe-table-column>
				<vxe-table-column show-footer-overflow field="routing_version" :title="$t('getapi[547]')" width="100"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="version_status" :title="$t('getapi[7569]')" width="100" ></vxe-table-column>
			</vxe-table>
		</div>

		<selector :isVisible="false" :isBatch=true :isSplitPage=true
				  :postUrl="'/Eng/Routings/GetEngRoutingMasterPopupList'" @callback="addRouting"  ref="routing"></selector>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';
    export default {
        name:'carftstatussetting',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            },
        },
        data() {
            return {
                fileList: [],
                itevisible:false,
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                loading: false, // 主表加载状态
                uploadurl: '',
                ischeck: false,
                scrollTop:0,
				btn:{
                    enablefalse: false,
                    enabletrue: false,
				},
                selectDataview:[],
                showCheckInfo: false,
                dataCheck:[],
                iscontinue: 0,//0:首次执行2：继续执行
            };
        },
        created () {
            setTimeout(() => {
                this.datajson = [];
            }, 1000)
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Eng/Routings/RouttingEnableImportUpFile?token=' + token;
            this.btnauthority();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted() {
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.CloseSoTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            btnauthority() {
                let that = this;
            },
            deleteAll(){
                let that = this;
                let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
                for(let i=selectRecords.length-1;i>=0;i--){
                    let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
                    that.datajson.splice(line, 1);
                }
            },
            download(){
                let param={
                    url:'/Eng/Routings/RouttingEnableTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if(file.response.DataContent.length>0){
                            that.datajson = file.response.DataContent;
                        }else{
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    if(res.DataContent.length>0){
                        that.datajson = res.DataContent;
                        that.iscontinue = 0
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }

                }
                that.fileList=[];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            setEnableFalse(val){
                let that = this
                let parm = {
                    LangType: that.$processdata.getLang(),
                    iscontinue: val,
                    Isreplace: 0,
                    Lists:that.selectDataview
                }
                that.$http.urlpost('/Eng/Routings/BatchRoutingEnabledFalse', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.datajson = res.DataContent;
                        that.iscontinue = 0
                    } else if(res.Success == 2){
                        that.datajson = res.DataContent
                        that.iscontinue = 2
                    }
                })
            },
            setEnableTrue(val){
                let that = this
                let parm = {
                    LangType: that.$processdata.getLang(),
                    iscontinue: val,
                    Isreplace: 0,
                    Lists:that.selectDataview
                }
                that.$http.urlpost('/Eng/Routings/BatchRoutingEnabledTrue', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.datajson = res.DataContent;
                        that.iscontinue = 0
                    } else if(res.Success == 2){
                        that.datajson = res.DataContent
                        that.iscontinue = 2
                    }
                })
            },
            handleSelectionChange({checked, records }){
                let that = this
                that.selectDataview = [];
                for(let i=0;i<records.length;i++){
                    that.selectDataview = [...that.selectDataview,{
                        status: records[i].status,
                        errmsg: '',
                        version_status:records[i].version_status,
                        partid: records[i].partid,
                        routingid: records[i].routingid,
                        routing_version: records[i].routing_version,
                        part_code: records[i].part_code,
                        part_version: records[i].part_version,
                        part_name: records[i].part_name,
                        part_status:records[i].part_status,
                    }]
                }
                that.btn.enablefalse = false
                that.btn.enablefalse = that.selectDataview.every(val => {
                    return val.version_status == '可用'
                });
                that.btn.enabletrue = false
                that.btn.enabletrue = that.selectDataview.every(val => {
                    return val.version_status == '不可用'
                })
			},
            handleSelectionChangeAll({ records }){
                let that = this;
                that.selectDataview = [];
                for(let i=0;i<records.length;i++){
                    that.selectDataview = [...that.selectDataview,{
                        status: records[i].status,
                        errmsg: '',
                        version_status:records[i].version_status,
                        partid: records[i].partid,
                        routingid: records[i].routingid,
                        routing_version: records[i].routing_version,
                        part_code: records[i].part_code,
                        part_version: records[i].part_version,
                        part_name: records[i].part_name,
                        part_status:records[i].part_status,
                    }]
                }
                that.btn.enablefalse = false
                that.btn.enablefalse = that.selectDataview.every(val => {
                    return val.version_status == '可用'
                });
                that.btn.enabletrue = false
                that.btn.enabletrue = that.selectDataview.every(val => {
                    return val.version_status == '不可用'
                })
			},
            selectRouting(){
                let that = this;
                that.$refs.routing.clearInput(true);
			},
			addRouting(data){
                let that = this
				console.log(data)
				that.iscontinue = 0
                let arr = data.filter(item => {
                    return that.datajson.every(item2 => {
                        return item.routingid != item2.routingid;
                    });
                });
                data = arr;
                for (let i = 0; i < data.length; i++) {
                    that.datajson = [
                        ...that.datajson,
                        {
                            part_code: data[i].part_code,
                            part_name: data[i].part_name,
                            part_version: data[i].part_version,
                            routing_version: data[i].routing_version,
                            partid:data[i].partid,
                            routingid:data[i].routingid,
                            version_status:data[i].version_status == 0?that.$t('getapi[231]'):that.$t('getapi[203]'),
                            part_status:data[i].part_status,
                            status:'',
                        }
                    ];
                }
			},
        }
    };
</script>

<style lang="scss" scoped>
	span.label-fade-enter {
		font-size: medium;
		margin-right: 20px;
	}
</style>
<style>
	.el-message-box {
		width: 600px;
	}
</style>
